import { useState } from 'react';
import ModalCloseButton from './ModalCloseButton';
import SelectField from '../Forms/SelectField';

const TransferOwnershipModal = ({
  admins,
  clubName,
  onClose,
  onTransfer,
  authUserUid,
}) => {
  const [selectedAdminUid, setSelectedAdminUid] = useState('');
  const selectedAdmin = admins.find((admin) => admin.uid === selectedAdminUid);
  const transferrableAdmins = admins.filter((admin) => admin.uid !== authUserUid);

  const handleTransfer = () => {
    if (selectedAdmin) {
      onTransfer(selectedAdmin);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <ModalCloseButton onClick={onClose} />

        <h3 className="modal-title">Transfer club ownership</h3>
        <div className="modal-body">
          <p className="modal-text">
            You can only transfer ownership to an existing Admin. You will be automatically demoted to
            Admin.
          </p>
        </div>

        <div className="modal-content">
          <SelectField
            value={selectedAdminUid}
            onChange={setSelectedAdminUid}
            label="New owner"
          >
            <option value="">Select an Admin to transfer to</option>
            {transferrableAdmins.map((admin) => (
              <option key={admin.uid} value={admin.uid}>
                {admin.name}
              </option>
            ))}
          </SelectField>
        </div>

        <div className="modal-footer">
          <button type="button" onClick={onClose} className="btn btn-secondary">
            <span className="btn-text">CANCEL</span>
          </button>
          <button
            type="button"
            onClick={handleTransfer}
            disabled={!selectedAdminUid}
            className="btn btn-danger"
          >
            <span className="btn-text">{selectedAdmin ? `TRANSFER TO ${selectedAdmin.name.toUpperCase()}` : 'TRANSFER'}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransferOwnershipModal;

